<div class="toolbar">
  <input
    type="text"
    class="input input-bordered w-56"
    placeholder="Nombre del Grupo"
    [disabled]="isDisabled('grupo')"
    [value]="grupoValue()"
    (keyup.enter)="buscarGrupos()"
    (input)="grupoValue.set($any($event.target).value)"
  />

  <input
    type="text"
    class="input input-bordered w-56"
    placeholder="Razón Social"
    [disabled]="isDisabled('razon')"
    [value]="razonValue()"
    (keyup.enter)="buscarGrupos()"
    (input)="razonValue.set($any($event.target).value)"
  />

  <input
    type="text"
    class="input input-bordered w-56"
    placeholder="RUC"
    [disabled]="isDisabled('ruc')"
    [value]="rucValue()"
    (keyup.enter)="buscarGrupos()"
    (input)="rucValue.set($any($event.target).value)"
  />

  <form [formGroup]="groupEjecutivos" style="display: flex;gap: 1rem;align-items: center;margin: 0rem;">
      <p-floatlabel variant="in" class="input-full-width">
        <p-multiSelect [options]="categoriaEjecutivos" formControlName="categoriaEjecutivos" [maxSelectedLabels]="1"  optionLabel="label"
        optionValue="value" styleClass="widthMinSelectGrupos"
        ></p-multiSelect>
        <label for="categoriaEjecutivos">Filtros de Grupos</label>
      </p-floatlabel>

      <p-floatlabel variant="in" class="input-full-width">
        <p-multiSelect [options]="categoriaEjecutivosClientes" formControlName="categoriaEjecutivosClientes" [maxSelectedLabels]="1"  optionLabel="label"
        optionValue="value" styleClass="widthMinSelect"
        ></p-multiSelect>
        <label for="categoriaEjecutivosClientes">Filtros de Clientes</label>
      </p-floatlabel>
  </form>

  <button pButton label="Buscar" icon="pi pi-search" (click)="buscarGrupos()" [disabled]="groupEjecutivos.invalid"></button>
  <button
    pButton
    pRipple
    label="Exportar a Excel"
    icon="pi pi-file-excel"
    class="p-button-success"
    (click)="exportTreeTableData()"
  ></button>
  <button pButton label="Crear Grupo" icon="pi pi-plus" class="p-button-success" (click)="abrirDialogCrear()"></button>
  <button pButton label="Volver a la Bandeja" icon="pi pi-backward" (click)="navegar('/MantClientes')"></button>
  <!-- <button pButton label="Página 6" icon="pi pi-backward" (click)="saltarAPaginaSeis()"></button> -->
</div>
<!-- <div class="flex align-items-center gap-3">
  <p-selectButton
    [options]="filterModes"
    [(ngModel)]="filterMode"
    optionLabel="label"
    optionValue="value"
    style="height: 2rem"
  ></p-selectButton>
</div> -->
<p-treeTable
  #tt
  class="treetable"
  [scrollable]="true"
  scrollHeight="450px"
  showGridlines
  [paginator]="true"
  [rows]="rows"
  [first]="first"
  [totalRecords]="totalGrupos"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  [rowsPerPageOptions]="[20, 30, 40]"
  [value]="gruposTree()"
  [loading]="loading()"
  [filterMode]="filterMode"
  (onPage)="onPageChange($event)"
  [tableStyle]="{ 'min-width': '50rem' }"
>

  <ng-template pTemplate="header">
    <tr>
      <th class="columna-nombre-grupo">Nombre Grupo</th>
      <th class="columna-ruc">RUC</th>
      <th class="columna-intermedia">Cliente</th>
      <th class="columna-intermedia">Detalle</th>
      <th class="columna-intermedia">Estado Sunat</th>
      <th class="columna-intermedia">Ejecutivo</th>
      <th class="columna-intermedia">Customer</th>
      <th class="columna-acciones">Acciones</th>
    </tr>
    <!-- 🔹 FILTROS POR COLUMNA -->
    <tr>
      <th>
        <div class="flex align-items-center gap-2">
          <input
            pInputText
            type="text"
            placeholder="Buscar específico..."
            [(ngModel)]="filtroTexto"
            (input)="aplicarFiltro(tt)"
            style="width: 70%;"
          />

          <div class="flex align-items-center gap-2">
            <p-radioButton
              name="tipoBusqueda"
              value="grupo"
              [(ngModel)]="filtroTipo"
              inputId="radioGrupo"
              (onClick)="aplicarFiltro(tt)"
            ></p-radioButton>
            <label for="radioGrupo">Grupo</label>

            <p-radioButton
              name="tipoBusqueda"
              value="cliente"
              [(ngModel)]="filtroTipo"
              inputId="radioCliente"
              (onClick)="aplicarFiltro(tt)"
            ></p-radioButton>
            <label for="radioCliente">Cliente</label>
          </div>
        </div>
      </th>
      <th><input pInputText type="text" placeholder="Filtrar RUC" (input)="tt.filter($any($event.target).value, 'entC_DocIden', 'contains')" /></th>
      <th><input pInputText type="text" placeholder="Filtrar Cliente" (input)="tt.filter($any($event.target).value, 'estado_desc', 'contains')" /></th>
      <th><input pInputText type="text" placeholder="Filtrar Detalle" (input)="tt.filter($any($event.target).value, 'detalle_desc', 'contains')" /></th>
      <th><input pInputText type="text" placeholder="Filtrar Sunat" (input)="tt.filter($any($event.target).value, 'estado_sunat', 'contains')" /></th>
      <th><input pInputText type="text" placeholder="Filtrar Ejecutivo" (input)="tt.filter($any($event.target).value, 'nomCompletoEjecutivo', 'contains')" /></th>
      <th><input pInputText type="text" placeholder="Filtrar Customer" (input)="tt.filter($any($event.target).value, 'nomCompletoCustomer', 'contains')" /></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr [ngClass]="{'fila-grupo': rowData.tipo === 'grupo', 'fila-cliente': rowData.tipo === 'cliente'}">
      <td class="columna-nombre-grupo">
        @if (rowData.tipo === 'grupo') {
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
          <span class="font-bold">
            {{ rowData.nombre_grupo }}
          </span>
        } @else {
          <span>
            {{ rowData.razon_social }}
          </span>
        }
      </td>

      <td class="columna-ruc">{{ rowData.tipo === 'cliente' ? rowData.entC_DocIden : '' }}</td>
      <td class="columna-intermedia">{{ rowData.tipo === 'cliente' ? rowData.estado_desc : '' }}</td>
      <td class="columna-intermedia">{{ rowData.tipo === 'cliente' ? rowData.detalle_desc : '' }}</td>
      <td class="columna-intermedia">{{ rowData.tipo === 'cliente' ? rowData.estado_sunat : '' }}</td>
      <td class="columna-intermedia">{{ rowData.tipo === 'cliente' ? rowData.nomCompletoEjecutivo : '' }}</td>
      <td class="columna-intermedia">{{ rowData.tipo === 'cliente' ? rowData.nomCompletoCustomer : '' }}</td>

      <!-- Acciones solo para grupo -->
      <td class="columna-acciones">
        @if (rowData.tipo === 'grupo') {
          <button
            style="width: 25px;height: 25px;"
            pButton
            icon="pi pi-pencil"
            class="p-button-rounded p-button-info p-mr-2"
            (click)="abrirDialogEditar(rowData)"
          ></button>
          <button
            style="width: 25px;height: 25px;"
            pButton
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger"
            (click)="eliminarGrupo(rowData)"
          ></button>
        }
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="8" class="text-center p-3 text-gray-500">
        <i class="pi pi-search" style="margin-right: .5rem;"></i>
        No se encontraron grupos o clientes para el filtro aplicado.
      </td>
    </tr>
  </ng-template>
</p-treeTable>

<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [baseZIndex]="1000"
  [maximizable]="true"
  [style]="{ width: '70vw' }"
  [header]="dialogTitle()"
>
  <!-- <form [formGroup]="grupoForm" class="form-container">
    <div class="form-grid">
      <div class="form-field">
        <label for="nombre-grupo">Nombre del Grupo</label>
        <input id="nombre-grupo" pInputText formControlName="nombre_grupo" class="input-full-width" />
      </div>
      <div class="form-field">
        <label for="descripcion">Descripción</label>
        <textarea id="descripcion" rows="2" cols="30" pTextarea formControlName="descripcion" class="textarea-full-width"></textarea>
      </div>
      <div></div>
    </div>
  </form> -->

  @if (dialogLoading()) {
    <div class="spinner-overlay">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (!dialogLoading()) {
    <div class="picklist-wrapper">
      <app-custom-picklist
        [sourceItems]="filteredSourceItems()"
        [targetItems]="filteredTargetItems()"
        [formularioDelPadre]="grupoForm"
        [clientTypes]="ListarTipoCliente"
        [showGroups]="filtroNoAsignadosPorGrupo()"
        [showClients]="filtroNoAsignadosPorCliente()"
        filterBy="filtro_cliente"
        sourceHeader="Clientes Disponibles"
        targetHeader="Clientes Seleccionados"
        (sourceFilterChange)="sourceFilter.set($event)"
        (targetFilterChange)="targetFilter.set($event)"
        (clientTypeFilterChange)="onSelectFilterChange($event)"
        (selectItem)="onSelectItem($event)"
        (deselectItem)="onDeselectItem($event)"
        (showGroupsChange)="filtroNoAsignadosPorGrupo.set($event)"
        (showClientsChange)="filtroNoAsignadosPorCliente.set($event)">
      </app-custom-picklist>
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton label="Cancelar" icon="pi pi-times" (click)="showDialog = false"></button>
      <button pButton label="Guardar" icon="pi pi-check" (click)="guardarGrupo()" [disabled]="disableGuardar"></button>
    </div>
  </ng-template>
</p-dialog>
<!-- Nuevo Diálogo de Autenticación -->
<p-dialog
  header="Validación de Clientes"
  [(visible)]="showAuthDialog"
  [modal]="true"
  [baseZIndex]="1001"
  [style]="{ width: '40vw' }"
>
  <!-- Pestañas de validación (solo visibles si hay mensajes de validación) -->
  @if (validationTabs().length > 0) {
    <div class="card">
      <p-tabs [value]="validationTabs().at(0).value">
          <p-tablist>
              @for (tab of validationTabs(); track tab.value) {
                  <p-tab [value]="tab.value">{{ tab.title }}</p-tab>
              }
          </p-tablist>
          <p-tabpanels>
              @for (tab of validationTabs(); track tab.value) {
                  <p-tabpanel [value]="tab.value">
                      <p class="whitespace-pre-line text-sm text-gray-700">{{ tab.content }}</p>
                  </p-tabpanel>
              }
          </p-tabpanels>
      </p-tabs>
      <div class="p-field mb-4">
        <label for="username" class="block text-sm font-medium text-gray-700">Usuario Administrador</label>
        <input id="username" type="text" #inputUser class="w-full p-2 border rounded-md" (keyup)="adminUsername.set(inputUser.value)" [value]="adminUsername()" />
      </div>

      <div class="p-field mb-4">
        <label for="password" class="block text-sm font-medium text-gray-700">Contraseña</label>
        <input id="password" type="password" #inputPassword class="w-full p-2 border rounded-md" (keyup)="adminPassword.set(inputPassword.value)" [value]="adminPassword()" />
      </div>

      @if (authError()) {
        <div class="text-red-500 text-sm mb-4">{{ authError() }}</div>
      }
    </div>
  }
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton label="Cancelar" icon="pi pi-times" (click)="closeAuthDialog()"></button>
      <button pButton label="Confirmar" icon="pi pi-check" (click)="onAuthConfirm()"></button>
    </div>
  </ng-template>
</p-dialog>
